const Tooltip = {
  baseStyle: {
    fontFamily: "tooltip",
    fontSize: "sm",
  },
}

export default Tooltip
